import { Modifier } from '../modifier';
import {
  ModifierPriority,
  ModifierTags,
  StatusEffect,
  type ModifierParams,
} from '../modifier.type';
import type { Die } from '../die.type';
import DieElement from '../../dice-tray/die.svelte';
import { StatusEffectRegistry } from '../status-effects';

export class Clumsy extends Modifier {
  static readonly baseTitle = 'Clumsy';
  static readonly baseText = 'Automatically reroll any highest face dierolls. Stable.';
  static readonly baseIcon = 'clumsy';
  static readonly baseTags = [ModifierTags.Bane];
  static readonly basePriority = ModifierPriority.Middle;

  // Instance properties that can change
  title = Clumsy.baseTitle;
  text = Clumsy.baseText;
  icon = Clumsy.baseIcon;
  tags: Array<ModifierTags> = [...Clumsy.baseTags];
  priority = Clumsy.basePriority;

  update(stacks: number, params?: ModifierParams) {
    super.update(stacks, params);
    this.delay = true;
  }

  endTurn() {
    if (this.delay) {
      this.delay = false;
    } else {
      this.removeStacks(1);
    }
  }

  rollMid(
    diceElements: Array<DieElement>,
    dice: Array<Die>,
    promises: Array<Promise<void | boolean>>,
  ) {
    // check if dice rolled value is 6, and if so reroll it
    dice.forEach((die, index) => {
      if (die.activeFace == 5 && diceElements[index]) {
        // diceElements[index].roll();
        promises.push(diceElements[index].roll());
      }
    });
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Clumsy, Clumsy);
